import { render } from "./RegisterInfor.vue?vue&type=template&id=7506667e"
import script from "./RegisterInfor.vue?vue&type=script&lang=js"
export * from "./RegisterInfor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__